import { BASE_URL } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICertifyingBody, ICertifyingBodyInput } from "models/certifyingBody";

export async function getCertifyingBodies(params: string = ""): Promise<ICertifyingBody[]> {
  const response = await axios.get(BASE_URL + "/api/certifyingbodies" + params);
  return response.data;
}

export async function getCertifyingBodyById(id: string): Promise<ICertifyingBody> {
  const response = await axios.get(BASE_URL + "/api/certifyingbodies/" + id);
  return response.data;
}

export async function addCertifyingBody(data: FormData) {
  const response = await axios.post(BASE_URL + "/api/certifyingbodies", data);
  return response.data;
}

export async function editCertifyingBody(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + "/api/certifyingbodies/" + id, data);
  return response.data;
}

export async function deleteCertifyingBody(id: string) {
  const response = await axios.delete(BASE_URL + "/api/certifyingbodies/" + id);
  return response.data;
}

export const CertifyingBodyCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "isActive",
    numeric: false,
    disablePadding: false,
    label: "T_active",
  },
  {
    id: "createdOn",
    numeric: false,
    disablePadding: false,
    label: "T_created_date",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];

